import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { GetterTypes } from "@/store";
import { IconType } from "@/types/icons";
import DesktopSelectChatWrapper from "../chat/chatContainer/DesktopSelectChatWrapper/DesktopSelectChatWrapper.vue";
import {
  useComputedValue,
  useGetDesktopChatSelectProperties,
  useGetMessageHandlers,
} from "@/composables";
import { createOneToOneChatIdsFromUserIds } from "@/utils/chat";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupForwardMessage',
  setup(__props) {

const authId = useComputedValue<number>(GetterTypes.GET_AUTH_ID);
const { handleSendForwardedMessage, clearForwardedMessage } =
  useGetMessageHandlers();

const { isAddMembersShown, members, addMember, removeMember } =
  useGetDesktopChatSelectProperties({
    // defaultMembers: Object.values(users.value),
    defaultMembers: [],
    isAddMembersShown: true,
  });

const saveChanges = () => {
  const memberIds = members.value.map((m) => m.id);
  const chatIds = createOneToOneChatIdsFromUserIds(memberIds, authId.value);

  handleSendForwardedMessage(chatIds);
  clearForwardedMessage();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DesktopSelectChatWrapper, {
    members: _unref(members),
    "item-icon": _unref(IconType).CHECKBOX_ON,
    title: _ctx.$t('popup.PopupForwardMessage.title'),
    "confirm-title": _ctx.$t('popup.PopupForwardMessage.confirm'),
    "is-add-members-shown": _unref(isAddMembersShown),
    onAddMember: _unref(addMember),
    onItemAction: _unref(removeMember),
    onConfirm: saveChanges
  }, null, 8, ["members", "item-icon", "title", "confirm-title", "is-add-members-shown", "onAddMember", "onItemAction"]))
}
}

})